const getCookie = (c_name: string) => {
  let i, x, y;
  if (typeof document == 'undefined') {
    return null;
  }
  const ARRcookies = document ? document?.cookie?.split(';') : [];
  for (i = 0; i < ARRcookies.length; i++) {
    x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
    y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
    x = x.replace(/^\s+|\s+$/g, '');
    if (x == c_name) {
      return unescape(y);
    }
  }
};

const setCookie = (cname: string, value: string, exdays: number) => {
  const exdate = new Date();
  exdate.setDate(exdate.getDate() + exdays);
  const cvalue =
    escape(value) +
    (exdays == null ? '' : ';path=/; expires=' + exdate.toUTCString());
  document.cookie = cname + '=' + cvalue;
};

const deleteCookie = (cname: string) => {
  if (typeof document === 'undefined') return;
  document.cookie = cname + '=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
};

export { setCookie, getCookie, deleteCookie };
